import { DashboardLayout } from "@/components/Dashboard/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useLanguage } from "@/contexts/LanguageContext";
import { PushNotificationManager } from "@/components/PushNotificationManager";
import { KPIManager } from "@/components/KPI/KPIManager";
import { CompanySettingsForm } from "@/components/Settings/CompanySettingsForm";
import { AISettingsForm } from "@/components/Settings/AISettingsForm";
import { VersionInfo } from "@/components/UpdateAlert";

const Settings = () => {
  const { t } = useLanguage();
  
  return (
    <DashboardLayout>
      <div className="space-y-6 max-w-4xl">
        <div>
          <h2 className="text-3xl font-bold text-foreground">{t.settings.title}</h2>
          <p className="text-muted-foreground mt-1">
            {t.settings.subtitle}
          </p>
        </div>

        <Card className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-6">{t.settings.general}</h3>
          <div className="space-y-4">
            <div>
              <Label htmlFor="workspace">{t.settings.workspaceName}</Label>
              <Input
                id="workspace"
                placeholder="My Workspace"
                className="mt-2"
                defaultValue="Magma Production"
              />
            </div>
            <div>
              <Label htmlFor="email">{t.settings.emailNotifications}</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@company.com"
                className="mt-2"
              />
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-6">{t.settings.preferences}</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <Label>{t.settings.realtimeUpdates}</Label>
                <p className="text-sm text-muted-foreground">
                  {t.settings.realtimeUpdatesDesc}
                </p>
              </div>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>{t.settings.emailAlerts}</Label>
                <p className="text-sm text-muted-foreground">
                  {t.settings.emailAlertsDesc}
                </p>
              </div>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>{t.settings.dataExport}</Label>
                <p className="text-sm text-muted-foreground">
                  {t.settings.dataExportDesc}
                </p>
              </div>
              <Switch />
            </div>
          </div>
        </Card>

        <CompanySettingsForm />

        <AISettingsForm />

        <VersionInfo />

        <PushNotificationManager />

        <KPIManager />
      </div>
    </DashboardLayout>
  );
};

export default Settings;
